'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.both = both;
exports.start = start;
exports.end = end;
/**
 * 清除字符串 首尾空格
 */

function both(str) {
    return str.replace(/(^\s*)|(\s*$)/g, '');
}

function start(str) {
    return str.replace(/(^\s*)/g, '');
}

function end(str) {
    return str.replace(/(\s*$)/g, '');
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/utils/trim.js
// module id = 173
// module chunks = 0